import type { Profile } from '@features/profile/profile.types';

import type { CitizenshipFormState } from './useEditCitizenshipPanel.types';

function buildInitialCitizenshipFormState(
  profile?: Profile
): CitizenshipFormState {
  return {
    lastGrantedCitizenship: profile?.lastGrantedCitizenship ?? '',
    currentPermanentResidency: profile?.currentPermanentResidency ?? '',
  };
}

export { buildInitialCitizenshipFormState };
